// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';
import wixLocation from 'wix-location'
import wixUsers from 'wix-users';
$w.onReady(function () {

$w("#button6").onClick( (event) => {
	let title = $w("#input8").value;
	let link ="";
	const words = title.split(' ');
	for (var i = 0; i < words.length; i++) {
		 link  = link+ words[i];
		
	}
wixData.query("Recipes")
  .eq("title", link)
  .eq("_owner", wixUsers.currentUser.id )
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
      $w("#error").show();
    } else {
		 $w("#error").hide();
      let toInsert = {
  "name":          title,
  "title": 			link,
  "price":          "0"
  };


$w("#button6").disable();
wixData.insert("Recipes", toInsert)
  .then( (results2) => {
		let item = results; //see item bel
		setTimeout(function(){
		$w(wixLocation.to("/add-recipes/"+  link));},200);
	} )
	.catch( (err) => {
		$w("#button6").label = "error";
	} );

    }
  } )
  .catch( (err) => {
    let errorMsg = err;
  } );	

 
} );
});
